import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HomeComponent} from './home.component';
import {ContactUsModule} from '../../views/contact-us/contact-us.module';
import {JsonLdSchemaModule} from '../../json-ld-schema/json-ld-schema.module';
import {CommonSectionsModule} from '../../views/common/common-sections.module';
import {MatOptionModule} from '@angular/material/core';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {RbiDisclaimerModule} from '../../common/rbi-disclaimer/rbi-disclaimer.module';
import {CoreTeamSectionModule} from '../../common/core-team-section/core-team-section.module';
import {CommonBorrowSectionModule} from '../common-borrow-sections/common-borrow-section.module';
import {WeHaveBeenInTheNewsModule} from '../../common/we-have-been-in-the-news/we-have-been-in-the-news.module';
import {AwardsAndAccreditationsModule} from '../../common/awards-and-accreditations/awards-and-accreditations.module';
import {MatButtonModule, MatFormFieldModule} from '@angular/material';

@NgModule({
    declarations: [HomeComponent],
    imports: [CommonSectionsModule, CommonBorrowSectionModule, JsonLdSchemaModule, CoreTeamSectionModule, ContactUsModule,
        MatInputModule, MatFormFieldModule, FormsModule, MatOptionModule, MatSelectModule, WeHaveBeenInTheNewsModule,
        AwardsAndAccreditationsModule, RbiDisclaimerModule, MatButtonModule]
})
export class HomeModule {
}
